import React from 'react';
import AssuranceLibrary from '@/app/pages/assurancelibrary';
import AuditorContextProvider from '../components/AuditorContextProvider';
import { useNavigate } from 'react-router-dom';

/**
 * Auditor Assurance Library component
 * 
 * Renders a read-only version of the Assurance Library page for auditor view
 * We use AuditorContextProvider to get the context providers but avoid duplicate headers
 */
const AuditorAssuranceLibrary: React.FC = () => {
  const navigate = useNavigate();

  // Create a navigation handler for back button
  const handleBackNavigation = () => {
    // Navigate to auditor dashboard or another appropriate location
    navigate('/auditor-view');
  };

  return (
    <AuditorContextProvider>
      {/* Pass isReadOnly={true} to assurance library to ensure read-only mode */}
      <AssuranceLibrary 
        isReadOnly={true}
        onBackNavigation={handleBackNavigation} 
      />
    </AuditorContextProvider>
  );
};

export default AuditorAssuranceLibrary;